export default {
	title: "Chamada de Fichas",
	initialize: "Chamar fichas Nº 1",
	letter: "Letra",
	table: {
		guideMedium: "Guia / Médium",
		noMedium: "(sem médium)",
		noGuide: "(sem guia)",
	},
	noLettersAvailable: "Nenhuma letra disponível",
	stats: {
		pending: "Pendentes",
		called: "Em atendimento",
		completed: "Finalizadas",
	},
	actions: {
		"queue.reset": "fila resetada",
		"global.reset": "global reset",
		"ticket.reset": "ficha resetada",
	},
	popup: {
		consultant: "Consulente",
		status: "Status",
		calledAt: "Chamado em",
		finishedAt: "Finalizado em",
		cancelledAt: "Cancelado em",
		totalTime: "Tempo total",
		call: "Chamar",
		finish: "Finalizar",
		recall: "Rechamar",
		reopen: "Reabrir",
		reset: "Reset",
		confirmReset: "Confirmar reset desta ficha?",
	},
	errors: {
		generic: "Ocorreu um erro",
		initialize: "Erro ao inicializar chamadas",
		next: "Erro ao chamar próxima ficha",
		ritualNotInProgress: "Este ritual não está em andamento. Apenas rituais abertos permitem chamada de fichas.",
		loadRitual: "Erro ao carregar ritual",
	},
	messages: {
		reopened: "Ficha reaberta com sucesso",
		reconnected: "Conexão restabelecida",
		called: "Ficha chamada com sucesso",
		finished: "Ficha finalizada com sucesso",
		recalled: "Ficha rechamada",
		resetDone: "Ficha resetada",
		globalResetDone: "Reset global realizado",
		initialized: "Fichas inicializadas com sucesso",
	},
	displayDrawer: "Mensagens da TV",
	quickMessage: "Mensagem rápida",
	sendToDisplay: "Enviar para TV",
	clearDisplay: "Limpar Display",
	fullscreen: "Tela cheia",
	exitFullscreen: "Sair",
	confirmDevReset: "Resetar TODAS as fichas? Esta ação não pode ser desfeita.",
	devReset: "Reset Dev",
};
